// Sentry initialization should be imported first!
import "./instrument";
import React, { useEffect, useRef, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import BarLoader from "react-spinners/BarLoader";
import Protected from "./Protected";
import useMediaQuery from "@mui/material/useMediaQuery";
import PopUp from "./WebPages/PopUp";
import LoginPenta from "./WebPages/LoginPenta";
// import Category from './WebPages/Category';
import Splash from "./Splash";
import Logout from "./Logout";
import SlideRoutes from "react-slide-routes";
import Header from "./WebPages/Header";
import NavBar from "./WebPages/NavBar";
import UserContext from "./context/UserContext";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TncPublic from "./WebPages/tncPublic";
import OrderDetails from "./WebPages/OrderDetails";
import ItemDetails from "./WebPages/ItemDetails";
import Spinner from "./WebPages/Spinner";
import Email from "./WebPages/Email";
import CSVfileUpload from "./WebPages/CSVfileUpload";
import Airpay from "./WebPages/Airpay";
import Aboutus from "./WebPages/AboutUs";
import Cancel from "./WebPages/Cancel";
import Failed from "./WebPages/Failed";
import SomethingWrong from "./WebPages/SomethingWrong";
import ReactGA from "react-ga4";
import ChatUIComponent from "./components/ChatComponent";
import SentryTest from "./components/SentryTest";
import Events from "./WebPages/Events";
import Discounts from "./WebPages/Discounts";
import DiscountProduct from "./WebPages/DiscountProduct";
import CouponProductDetails from "./WebPages/CouponProductDetails";
import Referrals from "./WebPages/Referrals";
import GamersClub from "./WebPages/GamersClub";
import WinnerForm from "./WebPages/WinnerForm";
import MatomoTracker from "@datapunt/matomo-tracker-js";

import ChakraProductDetails from "./WebPages/ChakraProductDetails";
const ProductList = React.lazy(() => import("./WebPages/ProductList"));
const Contactform = React.lazy(() => import("./WebPages/ContactForm"));
const Cart = React.lazy(() => import("./WebPages/Cart"));
const ProductDetails = React.lazy(() => import("./WebPages/ProductDetails"));
const Payment = React.lazy(() => import("./WebPages/Payment"));
const ProfilePage = React.lazy(() => import("./WebPages/ProfilePage"));
const Hfsp = React.lazy(() => import("./WebPages/Hfsp"));
const Tier = React.lazy(() => import("./WebPages/Tier"));
const Terms = React.lazy(() => import("./WebPages/Terms"));
const Help = React.lazy(() => import("./WebPages/Help"));
const AboutUs = React.lazy(() => import("./WebPages/AboutUs"));
const Login = React.lazy(() => import("./Login"));
const Test = React.lazy(() => import("./WebPages/test"));
const Thankyou = React.lazy(() => import("./WebPages/Thankyou"));
const Track = React.lazy(() => import("./WebPages/Track"));
const Wallet = React.lazy(() => import("./WebPages/Wallet"));
const UserState = React.lazy(() => import("./context/UserState"));
// const Splash = React.lazy(() => import('./Splash'));
const Return = React.lazy(() => import("./WebPages/Return"));
const Review = React.lazy(() => import("./WebPages/Review"));
const Register = React.lazy(() => import("./WebPages/Register"));
const LedgerPage = React.lazy(() => import("./WebPages/LedgerPage"));
const Privacy = React.lazy(() => import("./WebPages/Privacy"));
const Orders = React.lazy(() => import("./WebPages/Order"));
const Contact = React.lazy(() => import("./WebPages/Contact"));
const Support = React.lazy(() => import("./WebPages/Support"));
const Faq = React.lazy(() => import("./WebPages/Faq"));
const MobilePlans = React.lazy(() => import("./WebPages/MobilePlans"));
const Mob = React.lazy(() => import("./WebPages/Mob"));
const Congratulations = React.lazy(() => import("./WebPages/Congratulations"));
const Productgrid = React.lazy(() => import("./WebPages/Productgrid"));
const Category = React.lazy(() => import("./WebPages/Category"));
const Error = React.lazy(() => import("./WebPages/Error"));
const PaymentResult = React.lazy(() => import("./WebPages/PaymentResult"));
const Home = React.lazy(() => import("./WebPages/Home"));

const App = () => {
  ReactGA.initialize("G-45L54VWF5R");
  const divRef = useRef(null);
  const [isOpen, setIsopen] = useState(false);
  const [show, setShow] = useState(false);
  const [switchi, setSwitchi] = useState(false);
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode: prefersDarkMode ? "dark" : "light",
        },
      }),
    [prefersDarkMode]
  );

  React.useEffect(() => {
    var _mtm = (window._mtm = window._mtm || []);
    _mtm.push({ "mtm.startTime": new Date().getTime(), event: "mtm.Start" });
    var d = document,
      g = d.createElement("script"),
      s = d.getElementsByTagName("script")[0];
    g.async = true;
    g.src =
      "https://cdn.matomo.cloud/icespicexyz.matomo.cloud/container_XmhoUcpG.js";
    s.parentNode.insertBefore(g, s);
  }, []);

  const tracker = new MatomoTracker({
    urlBase: "staging.icespice.com	",
    siteId: 1,
    userId: "0", // optional, default value: `undefined`.

    heartBeat: {
      // optional, enabled by default
      active: true, // optional, default value: true
      seconds: 10, // optional, default value: `15
    },
    linkTracking: false, // optional, default value: true
    configurations: {
      // optional, default value: {}
      // any valid matomo configuration, all below are optional
      disableCookies: true,
      setSecureCookie: true,
      setRequestMethod: "POST",
    },
  });
  const scrollToTop = () => {
    // if(location.pathname.slice(0,9)!=="/products")
    divRef.current.scroll({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleBackNavigation = () => {
    // console.log(window.history)
    if (show === true) {
      window.history.go(-1);
    }
    setIsopen(false);
    setShow(false);
    setSwitchi(false);
  };

  const Sidebar = () => {
    if (isOpen === true) {
      // window.history.replaceState('fake-route', document.title, window.location.href);
      // console.log(window.history)
      if (window.history.state === "fake-route") {
        window.history.go(-1);
      }
      // setIsopen(false);
    } else {
      window.history.pushState(
        "fake-route",
        document.title,
        window.location.href
      );
      // console.log(window.history)

      setIsopen(true);
    }
  };
  const UpbarCart = () => {
    if (show === true) {
      setShow(false);
    } else {
      window.history.pushState(
        "fake-route",
        document.title,
        window.location.href
      );
      setShow(true);
    }
  };
  const popMob = () => {
    if (switchi === true) {
      // console.log("turning off")

      setShow(false);
    } else {
      // console.log("turning on")
      window.history.replaceState(
        "fake-route",
        document.title,
        window.location.href
      );
      setSwitchi(true);
    }
  };
  useEffect(() => {
    window.addEventListener("popstate", handleBackNavigation);
    scrollToTop();

    // window.addEventListener("popstate", e => {
    //   // Nope, go back to your page
    //   this.props.history.go(1);
    // });

    return () => {
      window.removeEventListener("popstate", handleBackNavigation);
    };
  });
  return (
    <>
      <UserState>
        <Router>
          {/* <div className="circleblur3"/> */}
          <div className="home-Class">
            {
              <div className="header-app">
                <Header />
              </div>
            }
            <div ref={divRef}>
              <SlideRoutes>
                <Route path="/*" element={<Error />} />
                <Route path="/auth-login/:session_token?" element={<PopUp />} />
                <Route path="/penta" element={<LoginPenta />} />
                <Route path="/s/:session_token?" element={<Splash />} />
                {/* <Route path="/events" element={<Events />} /> */}
                <Route path="/events" element={<Events />} />
                <Route
                  path="/home"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Home />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/paymentresult"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <PaymentResult />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/failed"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Failed />
                    </React.Suspense>
                  }
                />

                <Route
                  path="/Cancel"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Cancel />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/unknownerr"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <SomethingWrong />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/airpay"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Airpay />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/products/:catId?"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <ProductList />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/contactform"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Contactform />
                    </React.Suspense>
                  }
                />
                <Route
                  path="hunt"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Hfsp />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/cart"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Cart
                        UpbarCart={UpbarCart}
                        show={show}
                        setShow={setShow}
                      />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/email"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Email />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/productDetails/:id?"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <ProductDetails />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/chakra/productDetails/:id?"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <ChakraProductDetails />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/tier/:id?"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Tier />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/ticket/:id"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <ChatUIComponent />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/productgrid"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Productgrid />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/payment"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Payment />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <ProfilePage />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/mobile"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Mob
                        switchi={switchi}
                        setSwitchi={setSwitchi}
                        popMob={popMob}
                      />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/terms"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Terms />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/help"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Help />
                    </React.Suspense>
                  }
                />

                <Route
                  path="/aboutus"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Aboutus />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/return"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Return />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/review"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Review />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/login"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Login />
                    </React.Suspense>
                  }
                />
                <Route path="/test" element={<Test />} />
                <Route
                  path="/register"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Register />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/success"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Thankyou />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/track"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Track />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/discounted_stock"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <DiscountProduct />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/t&cp"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <TncPublic />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/privacy"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Privacy />
                    </React.Suspense>
                  }
                />
                {/* <Route
                  path="/discounts"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Discounts />
                    </React.Suspense>
                  }
                /> */}
                <Route
                  path="/ledger"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <LedgerPage />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/orders"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Orders />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/orderdetails"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <OrderDetails />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/itemdetails"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <ItemDetails />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/contact"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Contact />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/faq"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Support />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/faqs"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Faq />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/wallet"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Wallet />
                    </React.Suspense>
                  }
                />
                <Route path="/Logout" element={<Logout />} />
                <Route
                  path="/congratulations"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Congratulations />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/refer"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Referrals />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/csv"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <CSVfileUpload />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/category"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <Category />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/couponproductdetails/:id?"
                  element={
                    <React.Suspense fallback={<Spinner />}>
                      <CouponProductDetails />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/rewards-chakra"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <GamersClub />
                    </React.Suspense>
                  }
                />
                <Route
                  path="/winnerForm"
                  element={
                    <React.Suspense
                      fallback={
                        <Backdrop open={true} style={{ zIndex: "10000" }}>
                          <Spinner />
                        </Backdrop>
                      }
                    >
                      <WinnerForm />
                    </React.Suspense>
                  }
                />
              </SlideRoutes>
            </div>

            <NavBar Sidebar={Sidebar} isOpen={isOpen} setIsopen={setIsopen} />
          </div>
        </Router>
      </UserState>
    </>
  );
};
export default App;
